// extracted by mini-css-extract-plugin
module.exports = {"uikit-actions-block":"uikit-actions-block__3kFjZ","uikit-actions-block__item":"uikit-actions-block__item__257n5"};